import MainSidebar from "@/components/Shared/Utils/Themed/MainSidebar"
import MainContainer from "@/components/Shared/Utils/Themed/MainContainer"
import MainHeading from "@/components/Shared/Utils/Themed/MainHeading";
import MainHeadingActions from "@/components/Shared/Utils/Themed/MainHeadingActions";
import MainWrapper from "@/components/Shared/Utils/Themed/MainWrapper";
import MainAttachedSidebar from "@/components/Shared/Utils/Themed/MainAttachedSidebar";
import MainBreadcrumbs from "@/components/Shared/Utils/Themed/MainBreadcrumbs";
import MainInformationFact from "@/components/Shared/Utils/Themed/MainInformationFact";

import PrimaryRelativeFormControl from "@/components/Shared/Utils/Themed/PrimaryRelativeFormControl";
import PrimarySelect, {PrimarySelectItem} from "@/components/Shared/Utils/Themed/PrimarySelect";
import PrimaryButton from "@/components/Shared/Utils/Themed/PrimaryButton";
import PrimaryInput from "@/components/Shared/Utils/Themed/PrimaryInput";
import PrimaryLinked from "@/components/Shared/Utils/PrimaryLinked";

import ObjectFilter from "@/components/Shared/Utils/ObjectFilter";

import RefetchButton from "@/components/Shared/Utils/RefetchButton";
import CreateObjectButton from "@/components/Shared/Utils/CreateObjectButton";
import LargeOptionDefault from "@/components/Shared/Utils/LargeOptionPicker";

import ActionButton from "@/components/Shared/Utils/ActionButton";
import AsyncButton from "@/components/Shared/Utils/AsyncButton";

const LayoutUtils = {
    MainSidebar,
    MainAttachedSidebar,
    MainContainer,
    MainHeading,
    MainHeadingActions,
    MainWrapper,
    MainBreadcrumbs,
    MainInformationFact
}

const FormUtils = {
    RefetchButton,
    CreateObjectButton,
    ActionButton,
    AsyncButton,
    PrimaryButton,
    PrimarySelect,
    PrimarySelectItem,
    PrimaryInput,
    PrimaryRelativeFormControl
}

export default {
    RefetchButton,
    ActionButton,
    AsyncButton,
    PrimaryLinked,
    ObjectFilter,
    CreateObjectButton,
    LargeOptionDefault,
    FormUtils,
    LayoutUtils
}